const elButtonGroupKey = Symbol();

export { elButtonGroupKey };
//# sourceMappingURL=button.mjs.map
